// extracted by mini-css-extract-plugin
export default {"deadlineCards":"index_deadlineCards__47nw5","month":"index_month__XJ6eL","day":"index_day__X0hFA","tag":"index_tag__akrbv"};